exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3qXcK1OqMVs2g76nfHjQur{padding-inline-start:20px;padding-inline-end:20px}@media only screen and (min-width: 480px){._3qXcK1OqMVs2g76nfHjQur{padding-inline-start:36px;padding-inline-end:36px}}@media only screen and (min-width: 1280px){._3qXcK1OqMVs2g76nfHjQur{padding-inline-start:52px;padding-inline-end:52px}}.Lrl1mVTmxLV-MV-MfuBfV{margin-inline-start:20px;margin-inline-end:20px}@media only screen and (min-width: 480px){.Lrl1mVTmxLV-MV-MfuBfV{margin-inline-start:36px;margin-inline-end:36px}}@media only screen and (min-width: 1280px){.Lrl1mVTmxLV-MV-MfuBfV{margin-inline-start:52px;margin-inline-end:52px}}._3HMl5AY-LSYTgBPbvrFeb-{display:none}.O4A_OR5_59TZK5JEYLr8q{top:0;bottom:0;width:100dvw;height:100dvh;position:fixed;overflow:hidden}", ""]);

// exports
exports.locals = {
	"navbarHeight": "72px",
	"grid-sides": "_3qXcK1OqMVs2g76nfHjQur",
	"gridSides": "_3qXcK1OqMVs2g76nfHjQur",
	"grid-sides-margins": "Lrl1mVTmxLV-MV-MfuBfV",
	"gridSidesMargins": "Lrl1mVTmxLV-MV-MfuBfV",
	"hidden": "_3HMl5AY-LSYTgBPbvrFeb-",
	"video-stories-swiper": "O4A_OR5_59TZK5JEYLr8q",
	"videoStoriesSwiper": "O4A_OR5_59TZK5JEYLr8q"
};